import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { ModulosController } from '../modulos-controller';
import { ControlesInternosService } from '../../../providers/controles-internos-service';
import { UsuarioService } from '../../../providers/usuario-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { AlertService } from '../../../providers/alert-service';
import { ModalAdicionarPerguntaPage } from '../../modais/modal-adicionar-pergunta/modal-adicionar-pergunta';
import { ModalPlanoAcaoPage } from '../../modais/modal-plano-acao/modal-plano-acao';
import { ModalListaEvidenciaPage } from '../../modais/modal-lista-evidencia/modal-lista-evidencia';
import { ModalPreVisualizarControlesInternoPage } from '../../modais/modal-pre-visualizacao/controles-internos/modal-pv-controles-internos';
import { MenuService } from '../../../providers/menu-service';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { FileService } from "../../../providers/file-service";
import { ArquivosService } from "../../../providers/arquivos-service";
import { ModalNaoSeAplicaPage } from "../../modais/nao-se-aplica/modal-nao-se-aplica";
import { AGORA } from "../../../app/AGORA";
import { environment } from '../../../environments/environment';
import { AssinaturaService } from '../../../assinatura/assinatura-service';

declare function unescape(s: string): string;

@Component({
  selector: 'page-controles-internos',
  templateUrl: 'controles-internos.html',
  providers: [
    ControlesInternosService,
    AGORA
  ]
})
export class ControlesInternosPage extends ModulosController {
  // Lista Construtora da Página
  categoriasControlesInternos: any = [];
  listaCategoria: any = [];
  tiposResposta: any = [];
  mediaRespostasArray: any = [];
  mediaRespostas: number = 0;
  shownGroup: any = [];
  loading: boolean = true;
  loadingCM: boolean = true;
  loadingTL: boolean = true;
  loadingCI: boolean = true;
  perfil: any = null;
  PCAAtiva: any;

  // idModuloPCA: any;
  flNaoAplica: boolean = false;
  // idProcesso: any = 0;
  tipoArquivo: any;
  cdModulo: any;
  // idModuloAnalise: any;
  // tipoAnalise: any = null;
  // tipoEntidadeExercicio: any = null;
  // tipodocumento: any = null;
  // origemArquivo: any;
  // pecaProcessual: any;

  // arquivoVinculado: any;
  usuarioLogado: any;
  // isJurisdicionado: boolean;
  // isCGE: boolean;

  processandoArquivo: boolean = false;

  COD_MODULO_CONTROLE_INTERNO = 2;

  formularioControleInterno: any;

  //Construtor da Página
  constructor(
    public AGORA: AGORA,
    private controlesInternosService: ControlesInternosService,
    public alertService: AlertService,
    private fileService: FileService,
    public arquivosService: ArquivosService,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public menuService: MenuService,
    public usuarioService: UsuarioService,
    private assinaturaService: AssinaturaService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.setModuloId( this.COD_MODULO_CONTROLE_INTERNO );
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.PCAAtiva.isPCAAberta = this.gestaoPcaService.isPCAAberta();

    this.usuarioLogado = this.usuarioService.obtemUsuario();

    this.perfil = usuarioService.obterDadosUsuario().perfil.replace("(", "").replace(")", "");

    this.carregarModulo();
  }

  //  #region Carregamento e População
  populaArryMediaRepostas(callback, objetoMedia) {
    var found = this.mediaRespostasArray.some(function (el) {
      return el.idQuestao === objetoMedia.idQuestao;
    });

    if (found) {
      this.mediaRespostasArray = this.mediaRespostasArray.map((respostaMap) => {
        if (respostaMap.idQuestao == objetoMedia.idQuestao) {
          respostaMap = objetoMedia;
        } else {
          this.mediaRespostasArray.push(objetoMedia);
        }
        return respostaMap;
      });
    } else {
      this.mediaRespostasArray.push(objetoMedia);
    }
    this.mediaRespostas = 0;
    this.mediaRespostasArray.forEach(element => {
      this.mediaRespostas += element.valor;
    });
    this.mediaRespostas = Math.round((this.mediaRespostas / this.mediaRespostasArray.length) * 100) / 100;
    callback();
  }

  carregarModulo() {
    this.loadingCM = true;

    this.categoriasControlesInternos = [];
    this.obterTodosTiposResposta();
    this.carregarInformacoes();
    this.recuperarFormularioControleInterno();
  }

  carregarInformacoes() {
    this.loadingCI = true;
    this.controlesInternosService.obterQuestoesPCA().subscribe(data => {
      this.categoriasControlesInternos = data;

      this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 2).subscribe(data => {
        this.flNaoAplica = data.flNaoAplica;
        this.setIdModuloPca(data.moduloPca);
        this.loadingCI = false;
      }, error => {
        this.loadingCI = false;
        console.log("erro ao carregar modulo pca: " + error);
      });

      if (this.categoriasControlesInternos) {
        this.categoriasControlesInternos.map((categoria) => {
          this.shownGroup.push(categoria);
          return categoria.perguntas.map((questao) => {
            let objetoMedia = {
              idQuestao: questao.analista.idQuestaoResposta,
              valor: questao.analista.idResposta
            };
            this.populaArryMediaRepostas(function () {
            }, objetoMedia);
            return questao;
          });
        });
      }
    }, error => {
      this.loadingCI = false;
      console.log("erro: " + error);
    });
  }

  obterTodosTiposResposta() {
    this.loadingTL = true;
    this.controlesInternosService.obterTodosTiposResposta().subscribe(data => {
      this.tiposResposta = data;
      this.loadingTL = false;
    }, error => {
      console.log("erro: " + error);
      this.loadingTL = false;
    });
  }

  //  #endregion

  //  #region Métodos do Accordion
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }
  }

  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };

  onRepostaChange(idQuestaoResposta, valorResposta) {
    let objetoMedia = {
      idQuestao: idQuestaoResposta,
      valor: valorResposta
    };

    console.log(valorResposta);
    this.populaArryMediaRepostas(function () {
    }, objetoMedia);
  }

  //  #endregion

  // #region Métodos de Salvar

  isQuestionarioJurisdicionadoPreenchido(): boolean {
    let auxCont = 0;
    let auxCont2 = 0;
    let coutRetorno = 0;
    let auxContCategoria = 0;
    this.categoriasControlesInternos.forEach(categoria => {
      auxContCategoria++;
      categoria.perguntas.forEach(questao => {

        if (!this.verificaPlanoAcao(questao)) {
          // if (questao.justificativa == "" && questao.dsPlanoAcao == "") {
          //   if (auxCont2 == 0) {
          //     this.alertService.mostraAlerta("", "É necessário preencher todas as justificativas e planos de ação.");
          //     auxCont++;
          //     auxCont2++;
          //     coutRetorno++;
          //   }
          // } else
          if (questao.dsPlanoAcao == "") {
            if (auxCont == 0) {
              this.alertService.mostraAlerta("", "É necessário preencher todos os planos de ação.");
              auxCont++;
            }
            coutRetorno++;
          }
        }
        // } else if (questao.justificativa == "") {
        //   if (auxCont == 0) {
        //     this.alertService.mostraAlerta("", "É necessário preencher todas as justificativas.");
        //     auxCont++;
        //   }
        //   coutRetorno++;
        // }
      });
    });

    if ((auxContCategoria == this.categoriasControlesInternos.length) && coutRetorno == 0) {
      return true;
    }

    return false;
  }

  testImage: any;

  test() {

    // console.log("Window.screen.Height: "+ document.body.offsetHeight);
    // console.log("Window.screen.Height: "+ window.screen.height);
    // console.log("Window.outerHeight: "+ window.outerHeight);
    // console.log("Window.innerHeight: "+ window.innerHeight);
    // console.log("document.documentElement.clientHeight: "+ document.documentElement.clientHeight);
    // console.log("document.body.clientHeight: "+ document.body.clientHeight);
    // console.log("document.body.scrollHeight: "+ document.body.scrollHeight);
    // console.log("document.documentElement.scrollHeight: "+ document.documentElement.scrollHeight);
    //
    // let body = document.body;
    // let html = document.documentElement;
    //
    // let height = Math.max( body.scrollHeight, body.offsetHeight,
    //   html.clientHeight, html.scrollHeight, html.offsetHeight );

    let options = {
      height: 3600,
      width: window.screen.width,
      windowHeight: 3600,
      windowWidth: window.screen.width
    };

    html2canvas(document.body, options).then((canvas: any) => {
      let img = canvas.toDataURL('image/jpeg', 1.0);
      // let image = new Image();
      // image.src = img;
      // let w = window.open("");
      // w.document.write(image.outerHTML);
      let doc = new jsPDF("p", "mm", "a4");
      let width = doc.internal.pageSize.width;
      let height = doc.internal.pageSize.height;
      doc.addImage(img, 'JPEG', 0, 0, width, height);
      // let pdfToSave = doc.output();
      // let file = new File(pdfToSave, "controle-interno.pdf");
      doc.save('controle-interno.pdf');
    });
  }

  printData() {
    let options = {
      height: 3600,
      width: window.screen.width,
      windowHeight: 3600,
      windowWidth: window.screen.width
    };

    html2canvas(document.body, options).then((canvas: any) => {
      let img = canvas.toDataURL('image/jpeg', 1.0);
      let doc = new jsPDF("p", "mm", "a4");
      let width = doc.internal.pageSize.width;
      let height = doc.internal.pageSize.height;
      doc.addImage(img, 'JPEG', 0, 0, width, height);
      // let pdfToSave = doc.output('datauristring');
      // file = new File(pdfToSave, "controle-interno.pdf",{type: 'application/pdf'});

      doc.save('controles_internos.pdf');

    });
  }

  salvarFormulario() {

    this.processandoArquivo = true;

    let file: File = null;

    let options = {
      height: 3600,
      width: window.screen.width,
      windowHeight: 3600,
      windowWidth: window.screen.width
    };

    html2canvas(document.body, options).then((canvas: any) => {

      let img =canvas.toDataURL('image/jpeg', 1.0);
      let doc = new jsPDF("p", "mm", "a4");
      let width = doc.internal.pageSize.width;
      let height = doc.internal.pageSize.height;
      doc.addImage(img, 'JPEG', 0, 0, width, height);

      var outputBase64 = doc.output('datauristring');
      var preBlob = this.dataURItoBlob(outputBase64);
      file = new File([preBlob], "controle-interno.pdf", { type: 'application/pdf' });

      const idFormularioAnterior = this.formularioControleInterno ? this.formularioControleInterno.idArquivoVinculado : 0;
      this.controlesInternosService.salvarFormularioControleInterno(file, this.getIdModuloPca(), idFormularioAnterior)
                          .then( arquivo => {
                            this.recuperarFormularioControleInterno();
                            this.iniciarAssinatura(arquivo.idPca, arquivo.idArquivoVinculado, arquivo.pathArquivo);
                          })
                          .catch( error => {
                            this.processandoArquivo = false;
                            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar arquivo: " + error.mensagem);
                            console.log('Erro ao salvar o Formulário de Autoavaliação de Controle Interno', error);
                          });

    });
  }

  private iniciarAssinatura(idPca: any, idArquivoVinculado: any, caminhoArquivo: string) {

    const cpfSemFormatacao = environment.production ? this.usuario.dadosUsuario[0].cpf : environment.cpfAssinateTeste;
    const cpf = this.formatarCpf(cpfSemFormatacao);

    const opcoes = {
      arquivos: [caminhoArquivo],
      cpfUsuarioLogado: cpfSemFormatacao,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [{
        idPca: idPca, 
        idDocumento: idArquivoVinculado,
        cpfAssinante: cpf,
        perfil: this.usuarioService.obterDadosUsuario().perfil
      }],
      idPca: idPca,
      tipoArquivo: 'TIPO_VINCULADO'
    };

    this.assinaturaService.iniciarAssinatura(opcoes);
  }

  public assinaturaComSucesso() {
    console.log('assinaturaComSucesso');
    this.processandoArquivo = false;
  }

  public assinaturaComErro() {
    console.log('assinaturaComErro');
    this.processandoArquivo = false;
  }

  private formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  /*
  assinarArquivos() {

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivos(this.arquivoVinculado.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf, this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }
*/


  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  salvarQuestionarioJurisdicionado(finalizar, recarregarModulo: boolean) {

    let categoriasControlesInternosAux = [];
    this.categoriasControlesInternos.map((categoria) => {
      return categoria.perguntas.filter((questao) => {
        if (questao.resposta.valor == "0" || questao.resposta.valor == "") {
          questao.resposta.idResposta = 0;
          questao.resposta.valor = "";
        }
        else {
          let tipoRespostaTemp = this.tiposResposta.filter((tipoReposta) => questao.resposta.valor.toString() == tipoReposta.valor)[0];

          if (tipoRespostaTemp != null) {
            questao.resposta = tipoRespostaTemp;
          }
        }
        categoriasControlesInternosAux.push(questao);
        return questao;
      });
    });

    this.controlesInternosService.salvarQuestionario(categoriasControlesInternosAux, false).subscribe(() => {
      if (!finalizar) {
        this.alertService.mostraAlerta("Controles Internos", "Requisição salva com sucesso.");
      }

      if (recarregarModulo) {
        this.carregarModulo();
      }

    }, (error) => {
      console.log(error.mensagem);
      this.alertService.mostraAlerta("Controles Internos", error.mensagem);
    });

    //}
  }

  verificarPendencia(recarregarModulo: boolean): boolean {

    this.salvarQuestionarioJurisdicionado(true, recarregarModulo);

    let pendencias = "";

    this.categoriasControlesInternos.forEach(categoria => {
      categoria.perguntas.forEach(questao => {
        if (questao.resposta.valor == "") {
          pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";
          pendencias += "Inserir resposta;<br>"
        } else {
          if (questao.idQuestao == "61") {
            if (questao.resposta.valor == "1" && questao.evidencias.length == 0) {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";
              pendencias += "Adicionar evidência;<br>"
            } else if ((questao.resposta.valor == "2" || questao.resposta.valor == "3")
                       && (questao.evidencias.length == 0 || questao.dsPlanoAcao == "")) {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";

              if (questao.evidencias.length == 0) {
                pendencias += "Adicionar evidência;<br>"
              }

              if (questao.dsPlanoAcao == "") {
                pendencias += "Adicionar plano de ação;<br>"
              }
            } else if (questao.resposta.valor == "4" && questao.dsPlanoAcao == "") {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";
              pendencias += "Adicionar plano de ação;<br>"
            }
          } else {
            if (questao.resposta.valor == "1" && questao.dsPlanoAcao == "") {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";
              pendencias += "Adicionar plano de ação;<br>"
            } else if (questao.resposta.valor == "2" && (questao.evidencias.length == 0 || questao.dsPlanoAcao == "")) {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";

              if (questao.evidencias.length == 0) {
                pendencias += "Adicionar evidência;<br>"
              }

              if (questao.dsPlanoAcao == "") {
                pendencias += "Adicionar plano de ação;<br>"
              }
            } else if  ((questao.resposta.valor == "3" || questao.resposta.valor == "4") && questao.evidencias.length == 0) {
              pendencias += "<br><br>Pergunta " + questao.titulo.substring(0, 4) + " pendência(s):<br><br>";
              pendencias += "Adicionar evidência;<br>"
            }
          }
        }
      });
    });

    if (pendencias) {
      this.alertService.mostraAlerta("Favor verificar as pendência(s):", pendencias);
      return false;
    } else {
      this.alertService.mostraAlerta("Controle Interno", "Nenhuma pendência encontrada.");
      return true;
    }

  }

  assinarQuestionarioJurisdicionado() {

    if (this.verificarPendencia(false)) {
      let categoriasControlesInternosAux = [];

      this.categoriasControlesInternos.map((categoria) => {
        categoria.perguntas.filter((questao) => {
          categoriasControlesInternosAux.push(questao);
        });
      });

      this.controlesInternosService.salvarQuestionario(categoriasControlesInternosAux, true).subscribe(() => {
        this.salvarFormulario();
      }, () => {
        this.alertService.mostraAlerta("Controles Internos", "Houve um problema no salvamento.");
      });
    }

  }

  incluirNoCertificado() {
    let perguntasNaoRespondidas = "";
    let constReticenciasMaisPularLinhaHTML = "... <br><br>";

    this.buscarPerguntasNaoRespondidas().forEach(perguntaNaoRespondida => {
      perguntasNaoRespondidas += perguntaNaoRespondida.substring(0, 35) + constReticenciasMaisPularLinhaHTML;
    });

    if (perguntasNaoRespondidas != "") {
      this.alertService.mostraAlerta("Favor responder as perguntas abaixo:", perguntasNaoRespondidas);
    }
    else {
      let perguntasSemParecerAnalista = "";
      this.buscarPerguntasSemParecerDoAnalista().forEach(perguntaSemParecerAnalista => {
        perguntasSemParecerAnalista += perguntaSemParecerAnalista.substring(0, 35) + constReticenciasMaisPularLinhaHTML;
      });
      if (perguntasSemParecerAnalista != "") {
        this.alertService.mostraAlerta("Favor preencher o parecer das perguntas abaixo:", perguntasSemParecerAnalista);
      }
      else {

        let categoriasControlesInternosAux = this.filtrarCategoriasParaSalvarQuestionarioAnalista();

        this.salvarFlagIncluir();

        if (categoriasControlesInternosAux.length <= 0) {
          categoriasControlesInternosAux = this.filtrarCategoriasParaSalvarQuestionarioAnalista();
        }

        this.controlesInternosService.submeterQuestionarioAnalista(categoriasControlesInternosAux).subscribe(() => {

          this.alertService.mostraAlerta("Controles Internos", "Repostas submetidas com sucesso.");

          this.voltarPCA();

        }, error => {
          console.log("erro: " + error);
          this.alertService.mostraAlerta("Controles Internos", "Houve um erro ao submeter respostas.");
        });

      }
    }
  }

  salvarQuestionarioAnalistaParaPreVisualizacao() {
    let categoriasControlesInternosAux = this.filtrarCategoriasParaSalvarQuestionarioAnalista();
    this.salvarQuestionarioAnalista(categoriasControlesInternosAux, false);
  }

  salvarQuestionarioAnalista(categoriasControlesInternosAux: any = [], mostrarMensagemSucesso: boolean = true, recarregarModulo: boolean = true) {
    this.salvarFlagIncluir();

    if (categoriasControlesInternosAux.length <= 0) {
      categoriasControlesInternosAux = this.filtrarCategoriasParaSalvarQuestionarioAnalista();
    }

    this.controlesInternosService.salvarQuestionarioAnalista(categoriasControlesInternosAux).subscribe(() => {
      if (mostrarMensagemSucesso) {
        this.alertService.mostraAlerta("Controles Internos", "Repostas salvas com sucesso.");
      }
      if (recarregarModulo) {
        this.carregarModulo();
      }
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("Controles Internos", "Houve um erro ao salvar respostas.");
    });
  }

  salvarFlagIncluir() {
    let categoriasControlesInternosAux = [];
    this.categoriasControlesInternos.map((categoria) => {
      return categoria.perguntas.map((questao) => {
        questao.analista.idQuestaoResposta = questao.idQuestaoResposta;

        if (questao.analista.valor == "0" || questao.analista.valor == "") {
          questao.analista.idResposta = 0;
          questao.analista.valor = "";
        }
        else {
          let tipoRespostaTemp = this.tiposResposta.filter((tipoReposta) => questao.analista.valor == tipoReposta.valor)[0];

          if (tipoRespostaTemp != null) {
            questao.analista.idResposta = tipoRespostaTemp.idResposta;
          }
        }

        categoriasControlesInternosAux.push(questao);
        return questao;
      });
    });

    this.controlesInternosService.salvarQuestionario(categoriasControlesInternosAux, false).subscribe(() => {
    }, () => {
      this.alertService.mostraAlerta("Controles Internos", "Houve um problema no salvamento do campo Incluir.");
    });
  }

  //  #endregion

  // #region Auxiliares de Validação

  buscarPerguntasNaoRespondidas(): any[] {
    let perguntasNaoRespondidas = [];
    this.categoriasControlesInternos.forEach(categoria => {
      categoria.perguntas.forEach(questao => {
        if (questao.analista.idResposta == "0") {
          perguntasNaoRespondidas.push(questao.titulo);
        }
      });
    });

    return perguntasNaoRespondidas;
  }

  buscarPerguntasNaoRespondidasJurisdicionado(): any[] {
    let perguntasNaoRespondidas = [];
    this.categoriasControlesInternos.forEach(categoria => {
      categoria.perguntas.forEach(questao => {
        if (questao.resposta.idResposta == "0") {
          perguntasNaoRespondidas.push(questao.titulo);
        }
      });
    });

    return perguntasNaoRespondidas;
  }

  buscarEvidenciasNaoEnviadasJurisdicionado(): any[] {
    let evidenciasNaoEnviadas = [];
    this.categoriasControlesInternos.forEach(categoria => {
      categoria.perguntas.forEach(questao => {
        if (!this.verificaEvidencia(questao) && questao.evidencias.length == 0) {
          evidenciasNaoEnviadas.push(questao.titulo);
        }
      });
    });

    return evidenciasNaoEnviadas;
  }

  buscarPerguntasSemParecerDoAnalista(): any[] {
    let perguntasSemParecerAnalista = [];
    this.categoriasControlesInternos.forEach(categoria => {
      categoria.perguntas.forEach(questao => {
        if ((questao.analista.idResposta != "0" && questao.analista.dsRespAnalista == "") && (questao.analista.idResposta != questao.resposta.idResposta)) {
          perguntasSemParecerAnalista.push(questao.titulo);
        }
      });
    });

    return perguntasSemParecerAnalista;
  }

  // #endregion

  // #region Auxiliares para Salvar

  filtrarCategoriasParaSalvarQuestionarioAnalista() {
    let categoriasControlesInternosAux = [];

    this.categoriasControlesInternos.map((categoria) => {
      return categoria.perguntas.map((questao) => {
        questao.analista.idQuestaoResposta = questao.idQuestaoResposta;
        if (questao.analista.valor == "0" || questao.analista.valor == "") {
          questao.analista.idResposta = 0;
          questao.analista.valor = "";
        }
        else {
          let tipoRespostaTemp = this.tiposResposta.filter((tipoReposta) => questao.analista.valor == tipoReposta.valor)[0];

          if (tipoRespostaTemp != null) {
            questao.analista.idResposta = tipoRespostaTemp.idResposta;
          }
        }
        categoriasControlesInternosAux.push(questao.analista);
        return questao;
      });
    });

    return categoriasControlesInternosAux;
  }

  // #endregion

  // #region Modais

  modalEvidencia(categoriaId: any, pergunta: any, param: any) {
    this.salvarQuestionarioJurisdicionado(true, false);

    this.apresentaModalListaDeEvidencias("Lista de evidências", categoriaId, pergunta, param, ModalListaEvidenciaPage);
  }

  modalJutificativa(categoriaId: any, questaoId: any, param: any) {
    this.apresentaModalJustificativa("Justificativa", categoriaId, questaoId, param, ModalAdicionarPerguntaPage);
  }

  modalRepostaAnalista(categoriaId: any, questaoId: any, param: any) {
    this.apresentaModalParecerAnalista("Parecer Analista", categoriaId, questaoId, param, ModalAdicionarPerguntaPage);
  }

  modalPlanoAcao(categoriaRecebida: any, perguntarecebida: any) {
    this.apresentaModalPlanoDeAcao("Plano de Ação", categoriaRecebida, perguntarecebida, ModalPlanoAcaoPage);
  }

  apresentaModalListaDeEvidencias(titulo: String, categoriaId: any, pergunta: any, parametroEnviado: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, param2: parametroEnviado, param3: pergunta, jurisdicionado: this.isJurisdicionado, isCGE: this.isCGE });
    modal.onDidDismiss(retornoModal => {
      console.log("carregando módulo...")
      this.carregarModulo();
    });
    modal.present();
  }

  apresentaModalJustificativa(titulo: String, categoriaId: any, questaoId: any, parametroEnviado: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, param2: parametroEnviado, jurisdicionado: this.isJurisdicionado, isCGE: this.isCGE });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag && this.isJurisdicionado) {
        this.categoriasControlesInternos.filter((categoria) => categoria.idCategoriaQuestao == categoriaId).map((categoria) => {
          return categoria.perguntas.filter((questao) => questao.idQuestao == questaoId).map((questao) => {
            questao.justificativa = retornoModal.objeto;
            return questao;
          });
          ;
        });

      }
    });
    modal.present();
  }

  apresentaModalParecerAnalista(titulo: String, categoriaId: any, questaoId: any, parametroEnviado: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, param2: parametroEnviado, jurisdicionado: this.isJurisdicionado, analista: true });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.categoriasControlesInternos.filter((categoria) => categoria.idCategoriaQuestao == categoriaId).map((categoria) => {
          return categoria.perguntas.filter((questao) => questao.idQuestao == questaoId).map((questao) => {
            questao.analista.dsRespAnalista = retornoModal.objeto;
            return questao;
          });
          ;
        });
      }
    });
    modal.present();
  }

  apresentaModalPlanoDeAcao(titulo: String, categoriaRecebida: any, perguntaRecebida: any, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, param2: perguntaRecebida, idquestaoresposta: perguntaRecebida.idQuestao, jurisdicionado: this.isJurisdicionado, isCGE: this.isCGE });
    modal.onDidDismiss(retornoModal => {
      if (retornoModal && retornoModal.flag) {
        this.categoriasControlesInternos.filter((categoria) => categoria.idCategoriaQuestao == categoriaRecebida.idCategoriaQuestao).map((categoria) => {
          return categoria.perguntas.filter((questao) => questao.idQuestao == perguntaRecebida.idQuestao).map((questao) => {
            questao.dsPlanoAcao = retornoModal.objeto.dsPlanoAcaoAtual;
            questao.dtPlanoInicio = retornoModal.objeto.dataInicio;
            questao.dtPlanoFim = retornoModal.objeto.dataFim;
            return questao;
          });
          ;
        });
      }
    });
    modal.present();
  }

  previsualizarCertificado() {
    this.salvarQuestionarioAnalistaParaPreVisualizacao();
    {
      this.apresentaModalPreVisualizacao("Pré-visualização do Certificado", ModalPreVisualizarControlesInternoPage);
    }
    ;
  }

  apresentaModalPreVisualizacao(titulo: String, modalPage: any) {
    let modal = this.modalCtrl.create(modalPage, { param1: titulo, mediaRespostas: this.mediaRespostas, PCAAtiva: this.PCAAtiva, jurisdicionado: this.isJurisdicionado });
    modal.onDidDismiss(() => {
    });
    modal.present();
  }

  // #endregion
  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  verificaEvidencia(pergunta) {
    let verifica: boolean = false;

    if (pergunta.flInversao) {
      if (!pergunta.resposta.valor || pergunta.resposta.valor <= 3) {
        verifica = false;
      } else {
        verifica = true;
      }
    } else {
      if (!pergunta.resposta.valor || pergunta.resposta.valor <= 1) {
        verifica = true;
      } else {
        verifica = false;
      }
    }

    return verifica;
  }

  verificaPlanoAcao(pergunta) {
    let verifica: boolean = false;

    if (!pergunta.flInversao) {
      if (pergunta.resposta.valor > 2) {
        verifica = true;
      } else {
        verifica = false;
      }
    } else {
      if (pergunta.resposta.valor > 1) {
        verifica = false;
      } else {
        verifica = true;
      }
    }

    return verifica;
  }

  naoSeAplica() {

    this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 2).subscribe(data => {

      let titulo = "NÃO SE APLICA";
      let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
        {
          titulo: titulo,
          moduloPca: data,
          IdProcesso: data.moduloPca,
          tipoAnalise: 0,
          jurisdicionado: this.isJurisdicionado,
          isCGE: this.isCGE,
          origemArquivo: "NA",
          origemFilter: 'CONTRATO',
          tipoEntidadeExercicio: 0,
          tipoDocumento: 0
        });
      modal.onDidDismiss(retornoModal => {
        this.carregarModulo() ;
        if (retornoModal && retornoModal.flag) {
        }
      });

      modal.present();



    }, error => {
      console.log("erro ao carregar modulo pca: " + error);
    });

  }

  visualizarFormularioControleInterno() {

    if (this.formularioControleInterno) {
      this.loading = true;
      this.fileService.baixarArquivo(this.formularioControleInterno.idArquivoVinculado);
      this.loading = false;
    }
  }

  recuperarFormularioControleInterno() {
    this.controlesInternosService.getFormularioControleInterno(this.PCAAtiva.id)
                        .subscribe(result => {
                          this.formularioControleInterno = result;
                        }, error => console.log(error));

  }

  iniciarAssinaturaFormularioControleInterno() {
    if (this.formularioControleInterno && !this.formularioControleInterno.assinado) {
      this.iniciarAssinatura(this.PCAAtiva.id, this.formularioControleInterno.idArquivoVinculado, this.formularioControleInterno.pathArquivo);
    }
  }

  getTextoBotaoVisualizarFormulario() {

    if (this.formularioControleInterno) {
      return 'Visualizar formulário de autoavaliação';
    }

    return 'Finalize o módulo para gerar o formulário de autoavaliação'
  }

  getTextoBotaoAssinarFormulario() {

    if (!this.formularioControleInterno) {
      return 'Finalize o módulo para assinar o formulário de autoavaliação'
    }

    if (this.formularioControleInterno.assinado) {
      return 'Formulário de autoavaliação assinado';
    } else {

      return 'Clique para assinar o formulário de autoavaliação';
    }
  }

  getColorBotaoAssinarFormulario() {

    if (!this.formularioControleInterno) {
      return 'primary';
    }

    if (this.formularioControleInterno.assinado) {
      return 'secondary';
    } else {
      return 'danger';
    }
  }

  isMostrarCursorDefault(): boolean {

    if (!this.formularioControleInterno || this.formularioControleInterno.assinado) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/controles-internos/controles-internos.ts